import 'react-toastify/dist/ReactToastify.css';
import { Typography } from '@material-ui/core';
import { toast, ToastContainer } from 'react-toastify';
import css from './styles.module.scss';
import React from 'react';

import { ToastOptions } from 'react-toastify';

export interface INotifyOptions extends ToastOptions {
    title?: string;
    message: string;
}
export type NotifyErrorAPI = (options: Omit<INotifyOptions, 'title'>) => void;
export type NotifyError = (options: INotifyOptions) => void;
export type NotifySuccess = (options: INotifyOptions) => void;

export const AppNotificationError: React.FC<{ title?: string; message: string }> = ({ title, message }) => {
    return (
        <>
            <Typography variant={'h5'} className={css.title}>
                {title}
            </Typography>
            <Typography className={css.message}>{message}</Typography>
        </>
    );
};

export const AppNotificationSuccess: React.FC<{ title?: string; message: string }> = ({ title, message }) => {
    return (
        <>
            <Typography variant={'h5'} className={css.title}>
                {title}
            </Typography>
            <Typography className={css.message}>{message}</Typography>
        </>
    );
};

export const notifyError: NotifyError = ({ title, message, ...options }) => {
    toast.error(<AppNotificationError title={title} message={message} />, { ...options, className: css['app-notify-error'] });
};

export const notifySuccess: NotifySuccess = ({ title, message, ...options }) => {
    toast.success(<AppNotificationSuccess title={title} message={message} />, { ...options, className: css['app-notify-success'] });
};

export const AppNotification: React.FC = () => {
    return <ToastContainer className={css.container} />;
};
